export type InventoryListColumnKey =
  | 'description'
  | 'location'
  | 'carton_configurations'
  | 'on_hand'
  | 'transfer'
  | 'allocated'
  | 'total'
  | 'actions';

export type InventoryListApiItem = {
  productId?: string;
  product?: {
    p_title?: string;
    p_sku?: string;
    p_images?: unknown;
    display_image?: unknown;
    package_dimensions?: Record<string, unknown>;
  };
  customerOrganization?: {
    company_name?: string;
    logo?: { url?: string };
  };
  locationSummary?: LocationSummary[];
  quantity?: {
    available?: number;
    transfer?: number;
    allocated?: number;
    total?: number;
  };
};

export type LocationSummary = {
  inventoryId?: string;
  lotNumber?: string;
  expiryDate?: string;
  zone?: { color?: string; code?: string };
  location?: { code?: string; isPickingLocation?: boolean };
  pallet?: { palletNumber?: string };
  cartonAttributes?: { alias?: string };
  quantity?: {
    available?: number;
    transfer?: number;
    allocated?: number;
    total?: number;
  };
};

export type InventoryLotRow = {
  item: InventoryListApiItem;
  lot: LocationSummary;
  lotIndex: number;
};

export function getProductRowKey(item: InventoryListApiItem): string {
  return `product-${item.productId ?? 'unknown'}`;
}

export function itemHasLots(item: InventoryListApiItem): boolean {
  return (item.locationSummary?.length ?? 0) > 0 && !!item.productId;
}

export function getLotCount(item: InventoryListApiItem): number {
  return item.locationSummary?.length ?? 0;
}

export function buildLotRows(item: InventoryListApiItem): InventoryLotRow[] {
  return (
    item.locationSummary?.map((lot, lotIndex) => ({
      item,
      lot,
      lotIndex,
    })) ?? []
  );
}

export function getLotRowKey(row: InventoryLotRow): string {
  return `lot-${row.lot.inventoryId ?? `${row.item.productId}-${row.lotIndex}`}`;
}
